import { Component, Input } from '@angular/core';
import { CustomButtonComponent } from "../../../../shared/components/custom-button/custom-button.component";
import { TranslocoPipe } from '@jsverse/transloco';
import { SetupIntentResult, Stripe, StripeElements, StripeElementsOptions } from '@stripe/stripe-js';
import { StripeService } from '../../../../core/services/stripe.service';

@Component({
  selector: 'app-payment-method-update',
  standalone: true,
  imports: [CustomButtonComponent, TranslocoPipe],
  templateUrl: './payment-method-update.component.html',
  styleUrl: './payment-method-update.component.css'
})
export class PaymentMethodUpdateComponent {
  stripe: Stripe | null = null;
  elements: StripeElements | null = null;
  paymentElement: any | null = null;
  @Input() clientSecret!: string;

  constructor(private stripeService: StripeService) { }

  async ngAfterViewInit(): Promise<void> {
    this.stripe = await this.stripeService.getStripe();

    if (!this.stripe) {
      console.error("Stripe failed to load");
      return;
    }

    const appearance: StripeElementsOptions["appearance"] = {
      theme: 'flat'
    };

    const options: StripeElementsOptions = {
      clientSecret: this.clientSecret,
      appearance: appearance,
    };


    this.elements = this.stripe.elements(options);
    this.paymentElement = this.elements.create('payment', { layout: "tabs" });

    this.paymentElement.mount('#payment-element');
  }

  async handleSubmit(event: Event) {
    event.preventDefault();

    if (!this.stripe || !this.elements) {
      console.error("Stripe not initialized");
      return;
    }

    const { setupIntent, error }: SetupIntentResult = await this.stripe.confirmSetup({
      elements: this.elements,
      confirmParams: {
        return_url: `${window.location.origin}/settings/billing`
      }
    });


    if (error) {
      const messageElement = document.getElementById('error-message');
      if (messageElement) {
        messageElement.textContent = error.message || 'Payment failed';
      }
    }
  }
}
